/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Table_HealthInputs */

const en_platform_table_health = /** @type {(inputs: Platform_Table_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uptime · p50`)
};

const zh_hans1_platform_table_health = /** @type {(inputs: Platform_Table_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可用率 · p50`)
};

const pt_br2_platform_table_health = /** @type {(inputs: Platform_Table_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponib. · p50`)
};

const es_platform_table_health = /** @type {(inputs: Platform_Table_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponibilidad · p50`)
};

const fr_platform_table_health = /** @type {(inputs: Platform_Table_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponibilité · p50`)
};

const de_platform_table_health = /** @type {(inputs: Platform_Table_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfügbarkeit · p50`)
};

const ru_platform_table_health = /** @type {(inputs: Platform_Table_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доступность · p50`)
};

const it_platform_table_health = /** @type {(inputs: Platform_Table_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponibilità · p50`)
};

/**
* | output |
* | --- |
* | "Uptime · p50" |
*
* @param {Platform_Table_HealthInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const platform_table_health = /** @type {((inputs?: Platform_Table_HealthInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Table_HealthInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_platform_table_health(inputs)
	if (locale === "pt-BR") return pt_br2_platform_table_health(inputs)
	if (locale === "es") return es_platform_table_health(inputs)
	if (locale === "fr") return fr_platform_table_health(inputs)
	if (locale === "de") return de_platform_table_health(inputs)
	if (locale === "ru") return ru_platform_table_health(inputs)
	if (locale === "it") return it_platform_table_health(inputs)
	return en_platform_table_health(inputs)
});